import React from 'react';
import { Link, Stack, Typography } from '@mui/material';
import { mdiArrowLeftThick } from '@mdi/js';
import { fullSize } from '../../../Constants';
import BgImage from '../../General/BackgroundImage/BgImage';
import AppIcon from '../../General/Icons/AppIcon';
import { useTranslation } from 'react-i18next';
import { vars } from '../../../Theme';

export default () => {
    const { t } = useTranslation('translations', { keyPrefix: 'errorView' });

    return (
        <Stack
            sx={{
                alignItems: 'center',
                justifyContent: 'center',
                ...fullSize,
            }}
        >
            <BgImage imageFile={'general-error-bg.jpg'} />
            <Stack
                direction='column'
                spacing={2.5}
                sx={{
                    alignItems: 'center',
                    maxWidth: '500px',
                    p: 2,
                }}
            >
                <Typography
                    variant='h2'
                    sx={{
                        color: 'error',
                    }}
                >
                    {t('oops')}
                </Typography>

                <Typography sx={{ fontSize: 'large', fontWeight: 'bold' }}>
                    {t('errorDescription')}
                </Typography>

                <Link
                    href='/'
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                    }}
                >
                    <AppIcon
                        path={mdiArrowLeftThick}
                        color={vars.brandGreen}
                        withLabel={true}
                        label={t('projectSelection')}
                        labelSx={{ fontSize: 'large', fontWeight: 'bold', color: vars.brandGreen }}
                    />
                </Link>
            </Stack>
        </Stack>
    );
};
